<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <gj-warehouse-select
            v-model="filter.warehouseIds"
            :fba="false"
            placeholder="全部仓库"
            multiple
        ></gj-warehouse-select>
        <gj-select
            v-model="filter.statusList"
            :options="inventoryOption"
            type="multi-check"
            placeholder="状态"
            width="140px"
        ></gj-select>
        <gj-creator-select
            v-model="filter.createUser"
        ></gj-creator-select>
        <gj-creator-select
            v-model="filter.checkUser"
            placeholder="处理人"
        ></gj-creator-select>
        <gj-search-input
            v-model="filter.code"
            width="140px"
            placeholder="请输入盘点单号"></gj-search-input>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button @click="productCounting" type="primary" v-if="$permission('storageCheck:productCheck')">产品盘点</gj-button>
      <gj-button @click="warehouseCounting" v-if="$permission('storageCheck:warehouseCheck')">仓库盘点</gj-button>
    </template>
    <template #tool-group>
      <gj-tool-group
          help
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          :columns="columns"
          adaptParent
          :data="tableData"
          :loading="loading"
          :pagination="pagination"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
      >
        <template v-slot:status="{row}">
          <gj-tag
              type="plain"
              shape="rectangle"
              :color="row.status | optionColor(inventoryOption)">
            {{ row.status | optionText(inventoryOption) }}
          </gj-tag>
        </template>
        <template v-slot:memo="{row}">
          <template v-if="row.status === inventoryStatusEnum.WAIT_CHECK">
            <gj-edit-input
                :item="row"
                :on-confirm="onConfirm"
                :pop-title="'编辑备注'"
                :value="row.memo"
                table-cell-edit
            ></gj-edit-input>
          </template>
          <template v-else>
            <gj-text :content="row.memo" width="100%">{{row.memo | defaultShow}}</gj-text>
          </template>
        </template>
        <template v-slot:op="{row}">
          <gj-button-group
              type="dropdown-op"
              :config="opBtnConfig(row)"
          ></gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {queryMixin, responseMixin} from "../../../../minxins";
  import {inventoryOption, inventoryStatusEnum, logOpType} from "./enum";
  import AppWarehouseCounting from './modal/warehouse-counting';
  import AppAddInventory from './modal/add-inventory';
  import AppStartCounting from './modal/start-counting';
  import AppInventoryDetail from './modal/inventory-detail';
  import {abolishStorageCheck, getInventoryPage, updateStorageCheckMemo} from "@/api/warehouse";
  import {isMeaningful} from "@/utils/common";
  import {exportFile} from "@/api/common";

  export default {
    name: "inventory",
    mixins: [queryMixin, responseMixin],
    data() {
      return {
        columns: [
          {id: 'code', header: '盘点单号', field: 'code', minWidth: '140px', copyable: true},
          {id: 'warehouseName', header: '盘点仓', field: 'warehouseName', minWidth: '120px'},
          {id: 'status', header: '状态', field: 'slot:status', minWidth: '120px'},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '120px'},
          {id: 'createUserName', header: '创建人', field: 'createUserName', minWidth: '120px'},
          {id: 'createTime', header: '创建时间', field: 'createTime', minWidth: '150px'},
          {id: 'checkUserName', header: '处理人', field: 'checkUserName', minWidth: '120px'},
          {id: 'completeTime', header: '完成时间', field: 'completeTime', minWidth: '150px'},
          {id: 'op', header: '操作', field: 'slot:op', minWidth: '150px'},
        ],
        tableData: [],
        inventoryOption: inventoryOption,
        inventoryStatusEnum: inventoryStatusEnum,
        filter: {
          warehouseIds: [],
          statusList: [],
          createUser: null,
          checkUser: null,
          code: null,
        },
        opBtnConfig: (row) => [
          {
            label: '详情',
            click: () => this.openDetail(row)
          }, {
            label: '开始盘点',
            show: () => row.status === this.inventoryStatusEnum.WAIT_CHECK && this.$permission('storageCheck:startCheck'),
            click: () => this.startCounting(row)
          }, {
            label: '作废',
            show: () => row.status === this.inventoryStatusEnum.WAIT_CHECK && this.$permission('storageCheck:abolish'),
            click: () => this.abolished(row)
          }, {
            label: '日志',
            click: () => this.viewLog(row.id)
          }, {
            label: '导出盘点结果',
            show: () => row.status === this.inventoryStatusEnum.COMPLETED && this.$permission('storageCheck:exportCheckResult'),
            click: () => exportFile(`/supply/storageCheck/exportCheckResult?id=${row.id}`, {})
          },
        ],
        notStorage: true
      }
    },
    methods: {
      $gjCacheCallback(params) {
        return {
          warehouseIds: params.warehouseIds
        };
      },
      $gjQuery() {
        this.loading = true;
        getInventoryPage({
          model: {
            ...this.filter
          },
          ...this.querySort,
          ...this.queryPagination,
        }).then((data) => {
          this.tableData = data.records;
          this.pagination = this.getPagination(data);
        }).complete(() => this.loading = false)
      },
      $gjQueryInitParams() {
        return {
          filter: {
            warehouseIds: [],
            statusList: [],
            createUser: null,
            checkUser: null,
            code: null,
          }
        }
      },
      onConfirm(memo, data, closeEditor) {
        updateStorageCheckMemo(data.id, memo)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$message.success('保存成功');
              this.$gjResetPage();
              closeEditor();
            })
          });
      },
      productCounting() {
        const modal = this.$gjCreate(AppAddInventory, {
          on: {
            after: (data) => {
              if (isMeaningful(data)) {
                this.startCounting(data);
              }
              this.$gjResetPage();
              modal.$gjDestroy();
            }
          }
        })
      },
      warehouseCounting() {
        this.$gjCreate(AppWarehouseCounting, {
          on: {
            after: () => {
              this.$gjResetPage();
            }
          }
        })
      },
      openDetail(row) {
        this.$gjCreate(AppInventoryDetail, {
          props: {
            item: row
          }
        })
      },
      startCounting(row) {
        const modal = this.$gjCreate(AppStartCounting, {
          props: {
            item: row
          },
          on: {
            after: () => {
              modal.$gjDestroy();
              this.$gjResetPage();
            }
          }
        })
      },
      abolished(row) {
        const modal = this.$gjCreate('gj-textarea-modal', {
          props: {
            header: `作废<span class="modal-secondary-title">${row.code}</span>`,
            label: '作废理由',
            labelWidth: '74px',
            contentStyle: {padding: '16px 20px 20px 20px'},
            notMargin: true
          },
          on: {
            submit: (reason) => {
              modal.confirmLoading = true;
              abolishStorageCheck(row.id, reason)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjNoticeQuery();
                    modal.$gjDestroy();
                  })
                }).complete(() => modal.confirmLoading = false)
            }
          }
        })
      },
      viewLog(id) {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: `/supply/storageCheck/logPage`,
            params: {
              model: {
                checkId: id
              }
            },
            columns: [
              {id: 'op', header: '操作分类', field: 'option:op', minWidth: '120px', options: logOpType},
              {id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '300px'},
              {id: 'opUser', header: '操作用户', field: 'createUserName', minWidth: '100px'},
              {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '130px'}
            ]
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
